// extracted by mini-css-extract-plugin
export default {"root":"InvestorChip_root__BNrmV"};